import { render, staticRenderFns } from "./WeekdaySelect.vue?vue&type=template&id=04cbc772&"
import script from "./WeekdaySelect.vue?vue&type=script&lang=js&"
export * from "./WeekdaySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports